import React from "react";
import { useSiteSettings } from "../siteSettings";
import sharedHero from "../images/field1.png";
import "./MyPageBanner.css";

/**
 * Page header over a background photo. `subtitle` is a short line under the
 * title; `children` renders extra meta (badges) below it.
 *
 * Banners that use the shared field photo show the client's
 * site_settings.hero_image_url instead when one is set. Page-specific
 * artwork (e.g. the Ligas image) is always kept.
 */
function MyPageBanner({ imageUrl, text, subtitle, children }) {
  const { loaded, heroImageUrl } = useSiteSettings();
  const usesSharedHero = imageUrl === sharedHero;

  let background = imageUrl;
  if (usesSharedHero) {
    // Wait for settings so a client's hero never flashes the default photo first.
    background = loaded ? heroImageUrl || sharedHero : null;
  }

  return (
    <header
      className="banner-container"
      style={{
        backgroundImage: background ? `url(${background})` : "none",
      }}
    >
      <div className="banner-copy">
        <h1 className="banner-text">{text || ""}</h1>
        {subtitle && <p className="banner-subtitle">{subtitle}</p>}
        {children && <div className="banner-meta">{children}</div>}
      </div>
    </header>
  );
}

export default MyPageBanner;
